import { useState } from "react";
import { BsCalendar2Check } from "react-icons/bs";
import ExpandPanel from "./ExpandPanel";

export default function AllWidget({ bookings }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  return (
    <div className="col-span-12 sm:col-span-3 border px-4 py-2 flex items-center bg-white hover:bg-red-50">
      <button className="flex" onClick={() => setVisible(true)}>
        <div className="flex justify-center items-center rounded-lg border h-12 w-12 bg-red-100">
          <BsCalendar2Check size={24} />
        </div>
        <div className="border-l ml-2">
          <div className="pl-4 ">All Bookings</div>
          <div className="pl-4 text-xl text-black text-left font-bold">
            {bookings.length}
          </div>
        </div>
      </button>
      <ExpandPanel
        isVisible={isVisible}
        setVisible={setVisible}
        data={bookings}
        title={"All Bookings"}
      />
    </div>
  );
}
